/**
 * Mensaje de campos inválidos del legacy.
 * Legacy (SuraTableMessages.properties): "Por favor ingrese correctamente los siguientes campos" seguido
 * de un renglón " - <campo>" por cada campo inválido; aquí se muestran en una sola línea.
 */
export const MSG_CAMPOS_INVALIDOS = 'Por favor ingrese correctamente los siguientes campos';

export function mensajeCamposInvalidos(campos: string[]): string {
  return `${MSG_CAMPOS_INVALIDOS}: ${campos.join(', ')}`;
}
